export const GET_USER_MEAL_PLAN = 'GET_USER_MEAL_PLAN';
export const GET_USER_MEAL_PLAN_SUCCESS = 'GET_USER_MEAL_PLAN_SUCCESS';
export const GET_USER_MEAL_PLAN_ERROR = 'GET_USER_MEAL_PLAN_ERROR';

export const SAVE_USER_MEAL_PLAN = 'SAVE_USER_MEAL_PLAN';
export const SAVE_USER_MEAL_PLAN_SUCCESS = 'SAVE_USER_MEAL_PLAN_SUCCESS';
export const SAVE_USER_MEAL_PLAN_ERROR = 'SAVE_USER_MEAL_PLAN_ERROR';

export const DELETE_USER_MEAL_PLAN = 'DELETE_USER_MEAL_PLAN';
export const DELETE_USER_MEAL_PLAN_SUCCESS = 'DELETE_USER_MEAL_PLAN_SUCCESS';
export const DELETE_USER_MEAL_PLAN_ERROR = 'DELETE_USER_MEAL_PLAN_ERROR';

export const SET_USER_MEAL_PLAN = 'SET_USER_MEAL_PLAN';
